import type { $Fetch } from "ofetch";

/**
 * Nome do Controller da API
 */
const controller = "/medico";

/**
 * Classe de gerenciamento de chamadas da API dos Médicos
 *
 * @class
 */
export default class MedicoApi {
    /**
     * Instância da dependência da API (ofetch)
     */
    private api;

    /**
     * Cria uma nova instância da classe MedicoApi.
     * @constructor
     * @param api - Instância da dependência da API (ofetch).
     */
    constructor(api: $Fetch) {
        this.api = api;
    }

    /**
   * @returns Lista de medicos (ComboBox)
   */
    listCbo(dataInicio?: string, dataFim?: string, itensPeriodo?: boolean) {
        const parameters: { [key: string]: any } = {};

        if (dataInicio) {
            parameters.dataInicio = dataInicio;
        }

        if (dataFim) {
            parameters.dataFim = dataFim;
        }

        parameters.itensPeriodo = itensPeriodo ?? false;

        return this.api<ApplicationModule[]>(`${controller}/listarmedicos-cbo`, {
            method: "GET",
            params: parameters
        });
    }

    /**
   * @returns Lista de medicos (ComboBox)
   */
    lerRegistro(codMedico?: number) {
        return this.api<ApplicationModule[]>(`${controller}/lerRegistro`, {
            method: "GET",
            params: {codMedico}
        });
    }

}